import axios from "axios";
import moment from "moment";

import { config } from "../../config";
import { LocalStorage } from '@/data/localstorage';
import { QueryInfo } from '@/util';
import { User } from '@/entity/authentication/user';


export class ManageUserDetails {
    
    async getUserDetails(userName: string): Promise<any> {
        // try {
            let response = await axios.get(config.api.host + "/admin/"+ userName, {
                headers : {
                    Authorization: new LocalStorage().authToken
                }
            });
           return Promise.resolve(response.data.data)
        // } catch(err) {
        //     return err;
        // }
        
    }

    async getUserPaymentHistoryByPage(page: number, size: number, userId: string): Promise<any> {
       
        let queryInfo: any = {
            page: page,
            "page-size" : size,
            userId: userId
        }

        let response = await axios.get(config.api.host + "/admin/getUserPaymentHistory" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response)
    }

    async getPaymentDetailsFromRazorpay(orderId: string): Promise<any> {
        let userId = localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/admin/" + userId + "/getUserPaymentDetailsFromRazorpay/" + orderId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data)
    }

    async updatePaymentDetailsFromRazorpay(paymentDetails: any): Promise<any> {
        let userId = localStorage.getItem("user.id")
        const response =  await axios.put(config.api.host + "/v1/admin/" + userId + "/paymentDetails", {
            data: {paymentDetails:paymentDetails}
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })

        return Promise.resolve(response.data.data)
    }
}